import React from 'react';
import classnames from 'classnames';
import { Drag, ArrowUp, ArrowDown } from 'components/ui/Icon/Streamline';
import Card from 'components/ui/Card';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import useWindowSize from 'hooks/useWindowSize';
import { SCREEN_SIZES } from 'constants/config';

const SortingChoicePreview = ({ disabledOption, text }) => {
  const size = useWindowSize();
  const isMobile = size.width < SCREEN_SIZES.MD;

  return (
    <Card
      className={classnames('d-f fd-r ai-c jc-sb px-14 text-center', {
        'py-10': !isMobile,
        'py-20': isMobile,
      })}
      mantleOverride
    >
      <div className="d-f fd-r ai-c ">
        <Drag className="fs-0" />
        <Text className="ml-8" variant={TEXT_VARIANTS.MANTLE_BODY}>
          {text}
        </Text>
      </div>
      <div className="d-f ai-c SortingChoice-actionButtons">
        <div
          className="IconButton h-cr-p SortingChoice-button"
          style={{ marginTop: 0 }}
          type="button"
          onClick={() => {}}
          onKeyDown={e => {}}
        >
          <ArrowUp
            className={classnames('SortingChoice-arrowIcon', {
              'SortingChoice-arrowIcon-disabled': disabledOption.up,
            })}
            size={isMobile ? 21 : 16}
          />
        </div>
        <div
          className="IconButton h-cr-p SortingChoice-button"
          style={{ marginTop: 0 }}
          type="button"
          onClick={() => {}}
          onKeyDown={e => {}}
        >
          <ArrowDown
            className={classnames('SortingChoice-arrowIcon', {
              'SortingChoice-arrowIcon-disabled': disabledOption.down,
            })}
            size={isMobile ? 21 : 16}
          />
        </div>
      </div>
    </Card>
  );
};

export default SortingChoicePreview;
